import React from 'react';
import { createRoot } from 'react-dom/client';
import './theme/global.css';
import theme from './theme/theme';
import applyTheme from './theme/applyTheme';
import App from './App';

applyTheme(theme);

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
